import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { SaleStatus, type Sale } from '@/types/api/sale';
import z from 'zod';

export const ListSalesSortKeySchema = z.enum(['name', 'createdAt', 'updatedAt']);

export const ListSalesParamsSchema = z
  .object({
    name: z.string(),
    status: z.array(z.nativeEnum(SaleStatus)),
    groupId: z.string(),
  })
  .partial();

export type ListSalesParams = z.infer<typeof ListSalesParamsSchema>;

export const listSales = async (params: ListSalesParams): Promise<Sale[]> => {
  return (await api.get(`/sales`, { params })).data;
};

export const listSalesQueryOptions = (params: ListSalesParams = {}) => {
  return queryOptions({
    queryKey: ['sales', params],
    queryFn: () => listSales(params),
  });
};

type UseSalesOptions = {
  queryConfig?: QueryConfig<typeof listSalesQueryOptions>;
  params?: ListSalesParams;
};

export const useSalesSuspense = ({ queryConfig, params }: UseSalesOptions) => {
  return useSuspenseQuery({
    ...listSalesQueryOptions(params),
    ...queryConfig,
  });
};
